import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { LANGUAGES, setLanguage } from "../../i18n";

// TR | EN anahtarı. variant="dark": koyu (sidebar) zemin; floating: oturumsuz sayfalarda sağ üst köşe.
export default function LanguageSwitcher({ variant = "light", floating = false, compact = false, block = false }) {
  const { t, i18n } = useTranslation();
  const current = (i18n.language || "tr").slice(0, 2);
  const dark = variant === "dark";
  const edge = dark ? "var(--text-sidebar)" : "var(--border-strong)";
  const text = dark ? "var(--text-sidebar)" : "var(--text-primary)";
  const activeBg = dark ? "var(--menu-active-bg)" : "var(--btn-primary)";
  const activeText = dark ? "var(--menu-active-color)" : "#fff";
  const langs = compact ? LANGUAGES.filter((l) => l !== current) : LANGUAGES; // dar sidebar: yalnızca diğer dile geçiş düğmesi

  return (
    <Box
      role="group"
      aria-label={t("common.language")}
      sx={{
        display: block ? "flex" : "inline-flex", width: block ? "100%" : undefined, border: `1px solid ${edge}`, borderRadius: "6px", overflow: "hidden",
        ...(floating ? { position: "fixed", top: 12, right: 16, zIndex: 1500, backgroundColor: "var(--bg-card)" } : {}),
      }}
    >
      {langs.map((lang) => {
        const active = current === lang;
        return (
          <Box
            component="button"
            key={lang}
            type="button"
            aria-pressed={active}
            aria-label={compact ? `${t("common.language")}: ${lang.toUpperCase()}` : undefined}
            onClick={() => setLanguage(lang)}
            sx={{
              minWidth: 36, minHeight: block ? 34 : 28, px: 1, flex: block ? 1 : undefined, fontSize: block ? 13 : 12, fontWeight: 700, border: "none", cursor: active ? "default" : "pointer",
              backgroundColor: active ? activeBg : "transparent", color: active ? activeText : text,
              "&:focus-visible": { outline: "2px solid var(--accent-navy-light)", outlineOffset: -2 },
              "&:hover": active ? {} : { backgroundColor: "var(--bg-hover)", color: "var(--text-primary)" },
            }}
          >
            {lang.toUpperCase()}
          </Box>
        );
      })}
    </Box>
  );
}
